// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___Ftd1","img":"styles_img__QOq3m","title":"styles_title__toHsr","desc":"styles_desc__og2BK","titleContainer":"styles_titleContainer__dqrgW"};